import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import {
  ClusterDataSource, DataSource, DataSourceService,
  ExportOptions, Feature, FeatureMotion, IgoMap, Layer, LayerService, MeasureLengthUnit,
  QueryableDataSourceOptions, SpatialFilterQueryType, SpatialFilterThematic,
  SpatialFilterType, VectorLayer, createOverlayMarkerStyle, featureToOl, moveToOlFeatures
} from '@igo2/geo';
import { ImportExportMode, ImportExportState, MapState, ToolState, WorkspaceState } from '@igo2/integration';
import { EventsKey } from 'ol/events';
import type OlFeature from 'ol/Feature';
import type OlGeometry from 'ol/geom/Geometry';
import olFormatGeoJSON from 'ol/format/GeoJSON';
import olSourceCluster from 'ol/source/Cluster';
import olClusterSource from 'ol/source/Cluster';
import olVectorSource from 'ol/source/Vector';
import * as olstyle from 'ol/style';
import { Observable, Subject, forkJoin, take, takeUntil, tap } from 'rxjs';
import { SigtSpatialFilterItemComponent } from './sigt-spatial-filter-item/sigt-spatial-filter-item.component';
import { SpatialFilterExtensionService } from 'src/app/shared/services/spatial-filter-extension.service';


import { SpatialFilterItemType } from './sigt-spatial-filter-item/sigt-spatial-filter-item.component';

import { Constantes } from 'src/app/shared/constantes';
import { ToolComponent } from '@igo2/common/tool';
import { EntityKey, EntityStore } from '@igo2/common/entity';
import { MessageService } from '@igo2/core/message';
import { LanguageService } from '@igo2/core/language';
import { SigtSpatialFilterTypeComponent } from './sigt-spatial-filter-type/sigt-spatial-filter-type.component';

@ToolComponent({
  name: 'sigt-spatial-filter',
  title: 'igo.integration.tools.sigtSpatialFilter',
  icon: 'selection-marker'
})
@Component({
    selector: 'app-sigt-spatial-filter',
    templateUrl: './sigt-spatial-filter.component.html',
    styleUrls: ['./sigt-spatial-filter.component.scss'],
    imports: [
        SigtSpatialFilterItemComponent,
        SigtSpatialFilterTypeComponent
    ]
})
export class SigtSpatialFilterComponent implements OnInit, AfterViewInit {
  @ViewChild(SigtSpatialFilterItemComponent, { static: true }) itemComponent: SigtSpatialFilterItemComponent;
  @Input() coords: [number, number];

  spatialType = SpatialFilterType;

  get map(): IgoMap {
    return this.mapState.map;
  }

  type: SpatialFilterType;
  itemType: SpatialFilterItemType = SpatialFilterItemType.LieuxVisibleLayers;

  public layers: Layer[] = [];
  public activeLayers: Layer[] = [];

  public queryType: SpatialFilterQueryType;
  public thematics: SpatialFilterThematic[];
  public zone: Feature;
  public zoneWithBuffer: Feature;
  public buffer = 0;

  public iterator = 1;

  private format = new olFormatGeoJSON();

  public store: EntityStore<Feature> = new EntityStore<Feature>([]); // Store to print results at the end

  public spatialListStore: EntityStore<Feature> = new EntityStore<Feature>([]);

  public loading = false;

  public thematicLength = 0;

  public measureUnit: MeasureLengthUnit = MeasureLengthUnit.Meters;
  private unsubscribe$ = new Subject<void>();

  private moveendKey: EventsKey;

  public defaultStyle: olstyle.Style | ((feature, resolution) => olstyle.Style);
  private options: { [p: string]: any };
  messagesDeValidation: { [key: string]: string } = {};

  constructor(
    private matIconRegistry: MatIconRegistry,
    private spatialFilterService: SpatialFilterExtensionService,
    private dataSourceService: DataSourceService,
    private layerService: LayerService,
    private mapState: MapState,
    private messageService: MessageService,
    private languageService: LanguageService,
    private importExportState: ImportExportState,
    private toolState: ToolState,
    private workspaceState: WorkspaceState,
    private cdRef: ChangeDetectorRef
  ) {
    this.messagesDeValidation.zeroResults = Constantes.MessageApplicatif.AucunElement_6I;
  }

  ngOnInit() {
    this.options = this.toolState.toolbox.getTool("sigt-spatial-filter")?.options;
    this.spatialFilterService.reinitialiserClesFicheDescriptive();
  }

  ngAfterViewInit(): void {
    if (this.coords) {
      this.itemComponent.effectuerRechercheOutilXY(this.coords);
    }
  }

  getOutputType(event: SpatialFilterType) {
    this.type = event;
    this.queryType = undefined;
  }

  getOutputQueryType(event: SpatialFilterQueryType) {
    this.queryType = event;
    if (this.queryType) {
      this.loadFilterList();
    }
  }

  activateExportTool() {
    const ids = [];
    const re = new RegExp('^Zone \\d+');
    for (const layer of this.layers) {
      if (!layer.title.match(re)) {
        ids.push(layer.id);
      }
    }
    this.importExportState.setMode(ImportExportMode.export);
    this.importExportState.setsExportOptions({ layers: ids } as ExportOptions);
    this.toolState.toolbox.activateTool('importExport');
  }

  activateWorkspace(record?) {
    let layerToOpenWks;
    this.workspaceState.store.entities$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        if (
          !record &&
          this.activeLayers.length &&
          this.workspaceState.store.all().length > 1
        ) {
          if (this.itemType === SpatialFilterItemType.Thematics) {
            for (const thematic of this.thematics) {
              if (!thematic.zeroResults) {
                layerToOpenWks = this.activeLayers.find((layer) =>
                  layer.title.includes(
                    thematic.name + ' ' + this.iterator.toString()
                  )
                );
                break;
              }
            }
            // } else if (this.itemType === SpatialFilterItemType.Address) {
            //   const title = 'Adresses ' + this.iterator.toString();
            //   this.activeLayers.forEach((layer) => {
            //     if (layer.title.includes(title)) {
            //       layerToOpenWks = layer;
            //     }
            //   });
          } else {
            //Selection de la premiere valeur résultat lieu
            if (this.activeLayers.length > 1) {
              //l'index 1 evite de montrer la couche de Zone par defaut et active le workspace d'un des couches
              layerToOpenWks = this.activeLayers[1];
            }
          }

          if (layerToOpenWks) {
            this.workspaceState.expanded.set(true);
            this.workspaceState.setActiveWorkspaceById(layerToOpenWks.id);
          }
        } else if (
          record &&
          this.activeLayers.length &&
          this.workspaceState.store.all().length > 1
        ) {
          this.selectWorkspaceEntity(record);
          this.moveendKey = this.map.ol.on('moveend', () => {
            this.selectWorkspaceEntity(record);
          });
        }
      });
  }

  private selectWorkspaceEntity(record) {
    this.workspaceState.store.all().forEach((workspace) => {
      workspace.entityStore.state.updateAll({ selected: false });
      if (workspace.title.includes(record.added[0].meta.title)) {
        this.workspaceState.setActiveWorkspaceById(workspace.id);
        workspace.entityStore.state.updateMany(record.added, {
          selected: true
        });
      }
    });
  }

  private loadFilterList() {
    this.spatialFilterService
      .loadFilterList(this.queryType)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((features: Feature[]) => {
        features.sort((a, b) => {
          if (a.properties.nom < b.properties.nom) {
            return -1;
          }
          if (a.properties.nom > b.properties.nom) {
            return 1;
          }
          return 0;
        });
        this.spatialListStore.clear();
        this.spatialListStore.load(features);
      });
  }

  getOutputToggleSearch() {
    this.loadThematics();
  }

  getOutputClearSearch() {
    this.zone = undefined;
    this.queryType = undefined;
  }

  clearMap() {
    this.layers?.forEach(layer => this.map.layerController.remove(layer));
    this.layers = [];
    this.activeLayers = [];
    this.thematicLength = 0;
    this.iterator = 1;
    if (
      this.type === SpatialFilterType.Predefined &&
      this.itemType !== SpatialFilterItemType.LieuxAllLayers &&
      this.itemType !== SpatialFilterItemType.LieuxVisibleLayers
    ) {
      this.zone = undefined;
      this.queryType = undefined;
    }
  }

  private loadThematics() {
    this.loading = true;
    let zeroResults = true;
    let thematics;
    if (this.buffer === 0 || this.type === SpatialFilterType.Point) {
      this.tryAddFeaturesToMap([this.zone]);
    }
    if (this.type === SpatialFilterType.Point && !(this.zone as any).radius) {
      //cette condition est pour garantir avoir un rayon dans le cercle pour la fiche descriptive des lieux
      (this.zone as any).radius = this.buffer;
    }
    if (this.itemType !== SpatialFilterItemType.Thematics) {
      const theme: SpatialFilterThematic = {
        name: ''
      };
      thematics = [theme];
    } else {
      thematics = this.thematics;
    }
    if (
      this.measureUnit === MeasureLengthUnit.Kilometers &&
      this.type !== SpatialFilterType.Point
    ) {
      this.buffer = this.buffer * 1000;
    }
    if (this.type === SpatialFilterType.Polygon) {
      this.buffer = 0; // to avoid buffer enter a second time in terrAPI
    }

    const observables$: Observable<Feature[]>[] = [];
    thematics.forEach((thematic) => {
      observables$.push(
        this.spatialFilterService
          .loadFilterItem(
            this.zone,
            this.itemType,
            this.queryType,
            thematic,
            this.buffer,
            this.getLayers(),
            this.options["maxFeatures"]
          )
          .pipe(
            tap((features: Feature[]) => {
              this.store.insertMany(features);
              const featuresPoint: Feature[] = [];
              const featuresLinePoly: Feature[] = [];
              let idPoint: EntityKey;
              let idLinePoly: EntityKey;
              features.forEach((feature: Feature) => {
                if (feature.geometry.type === SpatialFilterType.Point) {
                  feature.properties.longitude =
                    feature.geometry.coordinates[0];
                  feature.properties.latitude = feature.geometry.coordinates[1];
                  featuresPoint.push(feature);
                  idPoint = feature.meta.id;
                } else {
                  featuresLinePoly.push(feature);
                  idLinePoly = feature.meta.id;
                }
              });

              this.tryAddPointToMap(featuresPoint, idPoint);
              this.tryAddLayerToMap(featuresLinePoly, idLinePoly);
              if (features.length) {
                zeroResults = false;
                this.thematicLength += 1;
                thematic.zeroResults = false;
                this.cdRef.detectChanges();
              } else {
                thematic.zeroResults = true;
              }

              if (features.length >= 10000) {
                this.messageService.alert(
                  'igo.geo.spatialFilter.maxSizeAlert',
                  'igo.geo.spatialFilter.warning',
                  { timeOut: 10000 }
                );
              }
            })
          )
      );
    });

    forkJoin(observables$)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.loading = false;
        if (
          zeroResults &&
          this.itemType !== SpatialFilterItemType.LieuxVisibleLayers &&
          this.itemType !== SpatialFilterItemType.LieuxAllLayers
        ) {
          this.messageService.info(
            this.messagesDeValidation.zeroResults,
            'igo.geo.spatialFilter.warning',
            { timeOut: 10000 }
          );
        }
      });
  }

  onZoneChange(feature: Feature, buffer?: boolean) {
    this.zone = feature;
    if (feature) {
      buffer
        ? this.tryAddFeaturesToMap([feature], true)
        : this.tryAddFeaturesToMap([feature]);
      this.zoomToFeatureExtent(feature);
    }
  }

  /**
   * Try to add zone feature to the map overlay
   */
  public tryAddFeaturesToMap(features: Feature[], buffer?: boolean) {
    let i = 1;
    for (const feature of features) {
      if (this.type === SpatialFilterType.Predefined) {
        for (const layer of this.layers) {
          if (
            layer.options._internal &&
            layer.options._internal.code === feature.properties.code &&
            !buffer
          ) {
            if (!layer.title?.startsWith('Zone')) {
              const index = this.layers.indexOf(layer);
              this.layers.splice(index, 1);
            }
            return;
          }
          if (layer.title?.startsWith('Zone')) {
            this.activeLayers = [];
            const index = this.layers.indexOf(layer);
            this.layers.splice(index, 1);
            this.map.layerController.remove(layer);
          }
        }
      } else {
        if (buffer) {
          for (const layer of this.activeLayers) {
            if (
              this.activeLayers.length === 1 &&
              layer.title?.startsWith('Zone')
            ) {
              const index = this.layers.indexOf(layer);
              this.layers.splice(index, 1);
              this.map.layerController.remove(layer);
            }
          }
        }
        this.activeLayers = [];
      }
      for (const layer of this.layers) {
        if (layer.title?.startsWith('Zone')) {
          i++;
        }
      }
      this.defaultStyle = (_feature, resolution) => {
        const coordinates = (features[0] as any).coordinates;
        return new olstyle.Style({
          image: new olstyle.Circle({
            radius: coordinates
              ? this.buffer /
              Math.cos((Math.PI / 180) * coordinates[1]) /
              resolution
              : undefined,
            fill: new olstyle.Fill({
              color: 'rgba(200, 200, 20, 0.2)'
            }),
            stroke: new olstyle.Stroke({
              width: 1,
              color: 'orange'
            })
          }),
          stroke: new olstyle.Stroke({
            width: 1,
            color: 'orange'
          }),
          fill: new olstyle.Fill({
            color: 'rgba(200, 200, 20, 0.2)'
          })
        });
      };
      this.dataSourceService
        .createAsyncDataSource({
          type: 'vector',
          queryable: true
        } as QueryableDataSourceOptions)
        .pipe(take(1))
        .subscribe((dataSource: DataSource) => {
          const olLayer = this.layerService.createLayer({
            isIgoInternalLayer: true,
            title: ('Zone ' +
              i +
              ' - ' +
              this.languageService.translate.instant(
                'igo.geo.spatialFilter.spatialFilter'
              )) as string,
            workspace: { enabled: true },
            _internal: {
              code:
                this.type === SpatialFilterType.Predefined && this.queryType as any !== 'DirectionRegionalMRNF'
                  ? feature.properties.code
                  : undefined
            },
            source: dataSource,
            visible: true
          }) as VectorLayer;
          const featuresOl = features.map((f) => {
            return featureToOl(f, this.map.projection);
          });
          if (this.type !== SpatialFilterType.Predefined) {
            const type =
              this.type === SpatialFilterType.Point ? 'Cercle' : 'Polygone';
            featuresOl[0].set('nom', 'Zone', true);
            featuresOl[0].set('type', type, true);
          }
          const ol = dataSource.ol as olVectorSource | olClusterSource;
          ol.addFeatures(featuresOl);
          olLayer.ol.setStyle(this.defaultStyle);
          this.map.layerController.add(olLayer);
          this.layers.push(olLayer);
          this.activeLayers.push(olLayer);
          this.cdRef.detectChanges();
        });
    }
  }

  /**
   * Try to add point features to the map
   * Necessary to create clusters
   */
  private tryAddPointToMap(features: Feature[], id) {
    let i = 1;
    if (features.length) {
      if (this.map === undefined) {
        return;
      }
      for (const layer of this.layers) {
        if (layer.title?.startsWith(features[0].meta.title)) {
          i++;
        }
      }
      this.dataSourceService
        .createAsyncDataSource({
          type: 'cluster',
          id,
          queryable: true,
          distance: 120,
          meta: {
            title: 'Cluster'
          }
        } as QueryableDataSourceOptions)
        .pipe(take(1))
        .subscribe((dataSource: ClusterDataSource) => {
          const icon = features[0].meta.icon;
          let style: olstyle.Style;
          if (!icon) {
            style = createOverlayMarkerStyle();
          } else {
            style = this.createSvgIcon(icon) || createOverlayMarkerStyle();
          }

          const olLayer = this.layerService.createLayer({
            isIgoInternalLayer: true,
            title: (features[0].meta.title +
              ' ' +
              i +
              ' - ' +
              this.languageService.translate.instant(
                'igo.geo.spatialFilter.spatialFilter'
              )) as string,
            source: dataSource,
            visible: true,
            style
          });

          const featuresOl = features.map((feature) => {
            return featureToOl(feature, this.map.projection);
          });
          const ol = dataSource.ol as olSourceCluster;
          ol.getSource().addFeatures(featuresOl);
          if (this.layers.find((layer) => layer.id === olLayer.id)) {
            this.map.layerController.remove(
              this.layers.find((layer) => layer.id === olLayer.id)
            );
            i = i - 1;
            olLayer.title = (features[0].meta.title +
              ' ' +
              i +
              ' - ' +
              this.languageService.translate.instant(
                'igo.geo.spatialFilter.spatialFilter'
              )) as string;
            olLayer.options.title = olLayer.title;
          }
          this.iterator = i;
          this.map.layerController.add(olLayer);
          this.layers.push(olLayer);
          this.pushLayer(olLayer);
          this.cdRef.detectChanges();
        });
    }
  }

  private createSvgIcon(icon): olstyle.Style {
    let style: olstyle.Style;
    this.matIconRegistry.getNamedSvgIcon(icon).subscribe((svgObj) => {
      const xmlSerializer = new XMLSerializer();
      svgObj.setAttribute('width', '30');
      svgObj.setAttribute('height', '30');
      svgObj.setAttribute('fill', 'rgba(0, 128, 255)');
      svgObj.setAttribute('stroke', 'white');
      const svg = xmlSerializer.serializeToString(svgObj);
      style = new olstyle.Style({
        image: new olstyle.Icon({
          src: 'data:image/svg+xml;utf8,' + svg
        })
      });
    });
    return style;
  }
  /**
   * Try to add line or polygon features to the map
   */
  private tryAddLayerToMap(features: Feature[], id) {
    let i = 1;
    if (features.length) {
      if (this.map === undefined) {
        return;
      }
      for (const layer of this.layers) {
        if (layer.title?.startsWith(features[0].meta.title)) {
          i++;
        }
      }
      this.dataSourceService
        .createAsyncDataSource({
          type: 'vector',
          id,
          queryable: true
        } as QueryableDataSourceOptions)
        .pipe(take(1))
        .subscribe((dataSource: DataSource) => {
          const olLayer = this.layerService.createLayer({
            isIgoInternalLayer: true,
            title: (features[0].meta.title +
              ' ' +
              i +
              ' - ' +
              this.languageService.translate.instant(
                'igo.geo.spatialFilter.spatialFilter'
              )) as string,
            source: dataSource,
            visible: true
          });
          const featuresOl = features.map((feature) => {
            return featureToOl(feature, this.map.projection);
          });
          const ol = dataSource.ol as olVectorSource | olClusterSource;
          ol.addFeatures(featuresOl);
          if (this.layers.find((layer) => layer.id === olLayer.id)) {
            this.map.layerController.remove(
              this.layers.find((layer) => layer.id === olLayer.id)
            );
            i = i - 1;
            olLayer.title = (features[0].meta.title +
              ' ' +
              i +
              ' - ' +
              this.languageService.translate.instant(
                'igo.geo.spatialFilter.spatialFilter'
              )) as string;
            olLayer.options.title = olLayer.title;
          }
          this.map.layerController.add(olLayer);
          this.layers.push(olLayer);
          this.pushLayer(olLayer);
          this.cdRef.detectChanges();
        });
    }
  }

  zoomToFeatureExtent(feature) {
    if (feature) {
      const olFeature = this.format.readFeature(feature, {
        dataProjection: feature.projection,
        featureProjection: this.map.projection
      }) as OlFeature<OlGeometry>;
      moveToOlFeatures(
        this.map.viewController,
        [olFeature],
        FeatureMotion.Zoom
      );
    }
  }

  pushLayer(layer) {
    for (const lay of this.activeLayers) {
      if (lay.id === layer.id) {
        return;
      }
    }

    this.activeLayers.push(layer);
  }

  private getLayers(): Layer[] {
    const layers = this.map.layerController.all.filter((l) => {
      if (l.type === "group") return false;
      if (l.isIgoInternalLayer) return false;
      if (l.baseLayer) return false;
      if (!l.showInLayerList) return false;
      const layerType = l.dataSource.options?.type;
      switch (layerType) {
        case 'wms':
        case 'wfs':
        case 'arcgisrest':
        case 'imagearcgisrest':
          return true;
        case 'vector':
        case 'wmts':
        case 'xyz':
        case 'osm':
        case 'tiledebug':
        case 'carto':
        case 'tilearcgisrest':
        case 'websocket':
        case 'mvt':
        case 'cluster':
          return false;
        default:
          return false;
      }
    });
    if (
      this.itemType === SpatialFilterItemType.LieuxAllLayers ||
      this.itemType === SpatialFilterItemType.LieuxVisibleLayers
    ) {
      if (this.itemType === SpatialFilterItemType.LieuxVisibleLayers) {
        //TODO: add condition for in resolution range (scale visibility) if needed.
        return <Layer[]> layers.filter((l) => l.visible);
      } else {
        return <Layer[]> layers;
      }
    } else {
      return [];
    }
  }
}
